<template>
  <div class="checkbox-area">
    <div class="checkbox-area__content">
      <div :class="[`form-checkbox`]" @change="onchangeCheckbox">
        <input
          :id="`form-checkbox-${title}-${label}-${id}`"
          :name="`form-checkbox-${title}-${label}-${id}`"
          type="checkbox"
          :class="[`form-checkbox__field`]"
          :checked="checked"
          :value="value"
          :disabled="disabled"
        />
        <label
          :class="[
            `form-checkbox__label`,
            `has-tooltip`,
            `${computedLabel === 'no-label' ? 'form-checkbox--no-label' : ''}`,
          ]"
          :for="`form-checkbox-${title}-${label}-${id}`"
        >{{ computedLabel }}</label>
      </div>
    </div>
    <div v-if="typeof count !== 'undefined'">
      <label>{{ count || 0 }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Object],
      required: true,
    },
    label: {
      type: [String, Boolean],
      required: true,
    },
    count: {
      type: Number,
      required: false,
      default: undefined,
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedLabel() {
      return typeof this.label === "boolean"
        ? this.label
          ? "Yes"
          : "No"
        : `${this.label}` || "no-label";
    },
  },
  methods: {
    onchangeCheckbox(e) {
      this.$emit("onchange", e.target.checked, e);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-area {
  display: flex;
  align-items: center;
  padding: 6px 0;
  justify-content: space-between;

  & .checkbox-area__content {
    display: flex;
    align-items: center;
    white-space: nowrap;
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .form-checkbox--no-label {
    text-indent: -9999px;
  }
}
</style>
